import { Stack } from "@mui/material";
import { IAttachment } from "../../common/models/IAttachment";
import AttachmentListCard, { AttachmentListCardActionEnum } from "./AttachmentListCard";

import type { JSX } from "react";

export type AttachmentListProps = {
    attachments: Array<IAttachment>;
    onAction?: (action: AttachmentListCardActionEnum, attachment: IAttachment) => void;
};

export default function AttachmentList({
    attachments,
    onAction
}: AttachmentListProps): JSX.Element {

    return (
        <Stack
            spacing={1}
            direction="row"
            sx={{
                flexWrap: "wrap"
            }}
        >
            {attachments.map((attachment, index) => {
                return <AttachmentListCard
                    key={index}
                    attachment={attachment}
                    onAction={onAction} />;
            })}
        </Stack>
    );
}

export { AttachmentListCardActionEnum } from "./AttachmentListCard";

